export const getLondonTime = () => {
  let now = new Date();
  const bst = (() => {
    let start = new Date(now.getUTCFullYear(), 3, 0);
    start.setDate(start.getDate() - start.getDay());
    let end = new Date(now.getUTCFullYear(), 10, 0);
    end.setDate(end.getDate() - start.getDay());
    return {
      start: new Date(start.getFullYear(), start.getMonth(), start.getDate(), 1),
      end: new Date(end.getFullYear(), end.getMonth(), end.getDate(), 1),
    };
  })();

  if (now > bst.start && now < bst.end) {
    now.setUTCHours(now.getUTCHours() + 1);
  }

  return now;
};
